import { action, makeObservable, observable } from 'mobx';

import { FollowUpAccordionKeys } from '@/layouts/OrganizationLayout/NoteContent/followUp/FollowUpList/types';
import { ILocalStore } from '@/stores/interfaces/ILocalStore';

export class FollowUpAccordionItemsStore implements ILocalStore {
  keys: FollowUpAccordionKeys[];

  constructor(defaultKeys: FollowUpAccordionKeys[]) {
    this.keys = defaultKeys;

    makeObservable(this, {
      keys: observable.ref,
      setKeys: action.bound,
    });
  }

  setKeys(keys: FollowUpAccordionKeys[]) {
    this.keys = keys;
  }

  destroy() {
    // no to do
  }
}
